import { render, staticRenderFns } from "./ModalAdminList.vue?vue&type=template&id=127e3cf6&scoped=true"
import script from "./ModalAdminList.vue?vue&type=script&lang=js"
export * from "./ModalAdminList.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminList.vue?vue&type=style&index=0&id=127e3cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e3cf6",
  null
  
)

export default component.exports